import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import { useTranslations } from '@/providers/TranslationsProvider';
interface CookiePreferences {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
}
interface CookieConsentProps {
  onAccept: (preferences: CookiePreferences) => void;
  onReject: () => void;
  onAcceptAll?: () => void;
}
const CookieConsent: React.FC<CookieConsentProps> = t0 => {
  const $ = _c(125);
  const {
    onAccept,
    onReject,
    onAcceptAll
  } = t0;
  const {
    t
  } = useTranslations();
  const [showDetails, setShowDetails] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      essential: true,
      analytics: false,
      marketing: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [preferences, setPreferences] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const timer = setTimeout(() => setIsVisible(true), 100);
      return () => clearTimeout(timer);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== onAccept || $[4] !== onAcceptAll) {
    t4 = () => {
      if (onAcceptAll) {
        onAcceptAll();
      } else {
        onAccept({
          essential: true,
          analytics: true,
          marketing: true
        });
      }
    };
    $[3] = onAccept;
    $[4] = onAcceptAll;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleAcceptAll = t4;
  let t5;
  if ($[6] !== onAccept || $[7] !== preferences) {
    t5 = () => {
      onAccept(preferences);
    };
    $[6] = onAccept;
    $[7] = preferences;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleAcceptSelected = t5;
  let t6;
  if ($[9] !== onReject) {
    t6 = () => {
      onReject();
    };
    $[9] = onReject;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleRejectAll = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = key => {
      setPreferences(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const togglePreference = t7;
  const t8 = `fixed bottom-0 left-0 right-0 z-50 transform transition-transform duration-500 ease-out ${isVisible ? "translate-y-0" : "translate-y-full"}`;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute inset-0 bg-black/20 backdrop-blur-sm rounded-t-2xl" />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="shrink-0 w-12 h-12 bg-linear-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg"><span className="text-2xl">🍪</span></div>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t) {
    t11 = t("cookieConsent.title");
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <h3 className="text-xl font-bold dark:text-white mb-2 bg-linear-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">{t11}</h3>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t) {
    t13 = t("cookieConsent.description");
    $[18] = t;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <p className="text-gray-600 dark:text-gray-300 leading-relaxed">{t13}</p>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t12 || $[23] !== t14) {
    t15 = <div className="flex items-start space-x-4 flex-1">{t10}<div className="flex-1 min-w-0">{t12}{t14}</div></div>;
    $[22] = t12;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== showDetails) {
    t16 = () => setShowDetails(!showDetails);
    $[25] = showDetails;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t) {
    t17 = t("cookieConsent.customize");
    $[27] = t;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = `w-5 h-5 transition-transform duration-200 ${showDetails ? "rotate-180" : ""}`;
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t18) {
    t20 = <svg className={t18} fill="none" stroke="currentColor" viewBox="0 0 24 24">{t19}</svg>;
    $[30] = t18;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== t16 || $[33] !== t17 || $[34] !== t20) {
    t21 = <button onClick={t16} className="shrink-0 ml-4 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-all duration-200 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl" aria-label={t17}>{t20}</button>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t15 || $[37] !== t21) {
    t22 = <div className="flex items-start justify-between">{t15}{t21}</div>;
    $[36] = t15;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  const t23 = `overflow-hidden transition-all duration-300 ease-in-out ${showDetails ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`;
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Cookie Preferences</h4>;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shrink-0"><span className="text-white text-sm">✓</span></div>;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t) {
    t26 = t("cookieConsent.categories.essential.title");
    $[41] = t;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== t26) {
    t27 = <h5 className="font-semibold text-gray-900 dark:text-white text-sm mb-1">{t26}</h5>;
    $[43] = t26;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== t) {
    t28 = t("cookieConsent.categories.essential.description");
    $[45] = t;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t28) {
    t29 = <p className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">{t28}</p>;
    $[47] = t28;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] !== t27 || $[50] !== t29) {
    t30 = <div className="flex-1 min-w-0">{t27}{t29}</div>;
    $[49] = t27;
    $[50] = t29;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== preferences.essential) {
    t31 = <input type="checkbox" checked={preferences.essential} disabled={true} className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500 dark:focus:ring-green-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mt-1" />;
    $[52] = preferences.essential;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t30 || $[55] !== t31) {
    t32 = <div className="bg-linear-to-br from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 p-4 rounded-xl border border-green-200/50 dark:border-green-700/50"><div className="flex items-start space-x-3">{t25}{t30}{t31}</div></div>;
    $[54] = t30;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center shrink-0"><span className="text-white text-sm">📊</span></div>;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  let t34;
  if ($[58] !== t) {
    t34 = t("cookieConsent.categories.analytics.title");
    $[58] = t;
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  let t35;
  if ($[60] !== t34) {
    t35 = <h5 className="font-semibold text-gray-900 dark:text-white text-sm mb-1">{t34}</h5>;
    $[60] = t34;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] !== t) {
    t36 = t("cookieConsent.categories.analytics.description");
    $[62] = t;
    $[63] = t36;
  } else {
    t36 = $[63];
  }
  let t37;
  if ($[64] !== t36) {
    t37 = <p className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">{t36}</p>;
    $[64] = t36;
    $[65] = t37;
  } else {
    t37 = $[65];
  }
  let t38;
  if ($[66] !== t35 || $[67] !== t37) {
    t38 = <div className="flex-1 min-w-0">{t35}{t37}</div>;
    $[66] = t35;
    $[67] = t37;
    $[68] = t38;
  } else {
    t38 = $[68];
  }
  let t39;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = () => togglePreference("analytics");
    $[69] = t39;
  } else {
    t39 = $[69];
  }
  let t40;
  if ($[70] !== preferences.analytics) {
    t40 = <input type="checkbox" checked={preferences.analytics} onChange={t39} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mt-1" />;
    $[70] = preferences.analytics;
    $[71] = t40;
  } else {
    t40 = $[71];
  }
  let t41;
  if ($[72] !== t38 || $[73] !== t40) {
    t41 = <div className="bg-linear-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 p-4 rounded-xl border border-blue-200/50 dark:border-blue-700/50"><div className="flex items-start space-x-3">{t33}{t38}{t40}</div></div>;
    $[72] = t38;
    $[73] = t40;
    $[74] = t41;
  } else {
    t41 = $[74];
  }
  let t42;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center shrink-0"><span className="text-white text-sm">🎯</span></div>;
    $[75] = t42;
  } else {
    t42 = $[75];
  }
  let t43;
  if ($[76] !== t) {
    t43 = t("cookieConsent.categories.marketing.title");
    $[76] = t;
    $[77] = t43;
  } else {
    t43 = $[77];
  }
  let t44;
  if ($[78] !== t43) {
    t44 = <h5 className="font-semibold text-gray-900 dark:text-white text-sm mb-1">{t43}</h5>;
    $[78] = t43;
    $[79] = t44;
  } else {
    t44 = $[79];
  }
  let t45;
  if ($[80] !== t) {
    t45 = t("cookieConsent.categories.marketing.description");
    $[80] = t;
    $[81] = t45;
  } else {
    t45 = $[81];
  }
  let t46;
  if ($[82] !== t45) {
    t46 = <p className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">{t45}</p>;
    $[82] = t45;
    $[83] = t46;
  } else {
    t46 = $[83];
  }
  let t47;
  if ($[84] !== t44 || $[85] !== t46) {
    t47 = <div className="flex-1 min-w-0">{t44}{t46}</div>;
    $[84] = t44;
    $[85] = t46;
    $[86] = t47;
  } else {
    t47 = $[86];
  }
  let t48;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = () => togglePreference("marketing");
    $[87] = t48;
  } else {
    t48 = $[87];
  }
  let t49;
  if ($[88] !== preferences.marketing) {
    t49 = <input type="checkbox" checked={preferences.marketing} onChange={t48} className="w-4 h-4 text-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-purple-500 dark:focus:ring-purple-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mt-1" />;
    $[88] = preferences.marketing;
    $[89] = t49;
  } else {
    t49 = $[89];
  }
  let t50;
  if ($[90] !== t47 || $[91] !== t49) {
    t50 = <div className="bg-linear-to-br from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 p-4 rounded-xl border border-purple-200/50 dark:border-purple-700/50"><div className="flex items-start space-x-3">{t42}{t47}{t49}</div></div>;
    $[90] = t47;
    $[91] = t49;
    $[92] = t50;
  } else {
    t50 = $[92];
  }
  let t51;
  if ($[93] !== t32 || $[94] !== t41 || $[95] !== t50) {
    t51 = <div className="border-t border-gray-200/50 dark:border-gray-700/50 pt-6">{t24}<div className="grid gap-4 sm:grid-cols-1 md:grid-cols-3">{t32}{t41}{t50}</div></div>;
    $[93] = t32;
    $[94] = t41;
    $[95] = t50;
    $[96] = t51;
  } else {
    t51 = $[96];
  }
  let t52;
  if ($[97] !== t23 || $[98] !== t51) {
    t52 = <div className={t23}>{t51}</div>;
    $[97] = t23;
    $[98] = t51;
    $[99] = t52;
  } else {
    t52 = $[99];
  }
  let t53;
  if ($[100] !== t) {
    t53 = t("cookieConsent.acceptAll");
    $[100] = t;
    $[101] = t53;
  } else {
    t53 = $[101];
  }
  let t54;
  if ($[102] !== handleAcceptAll || $[103] !== t53) {
    t54 = <button onClick={handleAcceptAll} className="flex-1 bg-linear-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-2xl transition-all duration-200 transform hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">{t53}</button>;
    $[102] = handleAcceptAll;
    $[103] = t53;
    $[104] = t54;
  } else {
    t54 = $[104];
  }
  let t55;
  if ($[105] !== handleAcceptSelected || $[106] !== showDetails || $[107] !== t) {
    t55 = showDetails && <button onClick={handleAcceptSelected} className="flex-1 bg-linear-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold py-3 px-6 rounded-2xl transition-all duration-200 transform hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">{t("cookieConsent.acceptSelected")}</button>;
    $[105] = handleAcceptSelected;
    $[106] = showDetails;
    $[107] = t;
    $[108] = t55;
  } else {
    t55 = $[108];
  }
  let t56;
  if ($[109] !== t) {
    t56 = t("cookieConsent.rejectAll");
    $[109] = t;
    $[110] = t56;
  } else {
    t56 = $[110];
  }
  let t57;
  if ($[111] !== handleRejectAll || $[112] !== t56) {
    t57 = <button onClick={handleRejectAll} className="flex-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-semibold py-3 px-6 rounded-2xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">{t56}</button>;
    $[111] = handleRejectAll;
    $[112] = t56;
    $[113] = t57;
  } else {
    t57 = $[113];
  }
  let t58;
  if ($[114] !== t54 || $[115] !== t55 || $[116] !== t57) {
    t58 = <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-gray-200/50 dark:border-gray-700/50">{t54}{t55}{t57}</div>;
    $[114] = t54;
    $[115] = t55;
    $[116] = t57;
    $[117] = t58;
  } else {
    t58 = $[117];
  }
  let t59;
  if ($[118] !== t22 || $[119] !== t52 || $[120] !== t58) {
    t59 = <div className="relative bg-white/95 dark:bg-gray-900/95 backdrop-blur-md border-t border-gray-200/50 dark:border-gray-700/50 shadow-2xl rounded-t-2xl"><div className="max-w-4xl mx-auto px-4 py-6 sm:px-6 lg:px-8"><div className="flex flex-col space-y-6">{t22}{t52}{t58}</div></div></div>;
    $[118] = t22;
    $[119] = t52;
    $[120] = t58;
    $[121] = t59;
  } else {
    t59 = $[121];
  }
  let t60;
  if ($[122] !== t59 || $[123] !== t8) {
    t60 = <div className={t8}>{t9}{t59}</div>;
    $[122] = t59;
    $[123] = t8;
    $[124] = t60;
  } else {
    t60 = $[124];
  }
  return t60;
};
export default CookieConsent;